var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.enabled
        ? _c("DropFileZone", {
            on: {
              droppedFiles: function($event) {
                return _vm.onFileDrop($event)
              }
            },
            model: {
              value: _vm.dropped_files,
              callback: function($$v) {
                _vm.dropped_files = $$v
              },
              expression: "dropped_files"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            scrollable: "",
            transition: "dialog-transition",
            width: "fit-content"
          },
          model: {
            value: _vm.dropped_files_dialog,
            callback: function($$v) {
              _vm.dropped_files_dialog = $$v
            },
            expression: "dropped_files_dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "background" },
            [
              _c(
                "v-card-title",
                { staticClass: "subheading py-0 pr-0 background darken-1" },
                [
                  _vm._v("\n\t\t\t\tUpload de fichiers\n\t\t\t\t"),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.dropped_files_dialog = false
                          _vm.dropped_files = []
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c(
                  "table",
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Nom")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Type")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Poids")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Date de modification")]),
                        _vm._v(" "),
                        _c("th")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dropped_files, function(file, i) {
                      return _c(
                        "tbody",
                        { key: "file_" + i },
                        [
                          _c(
                            "tr",
                            {
                              class: [
                                {
                                  "background--text text--lighten-4":
                                    _vm.files_data[i].block_reasons.length > 0
                                },
                                { "primary--text": _vm.files_data[i].done },
                                { "error--text": _vm.files_data[i].error }
                              ]
                            },
                            [
                              _c("td", [_vm._v(_vm._s(file.name))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(file.type || "-"))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm._f("humanizeBytes1024")(file.size))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(file.lastModifiedDate)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm.files_data[i].uploading ||
                              _vm.files_data[i].done
                                ? _c("td", { staticClass: "text-right" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "subheading primary--text"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.files_data[i].progress) +
                                            "%\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ])
                                : _c(
                                    "td",
                                    [
                                      _vm.files_data[i].block_reasons.length ===
                                      0
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "text-none ma-0",
                                              attrs: {
                                                small: "",
                                                color: "primary color--text",
                                                loading: _vm.uploading
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.upload(
                                                    [file],
                                                    [_vm.files_data[i]]
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { color: "color" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\tupload_file\n\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t"
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.files_data[i].progress
                            ? _c("tr", [
                                _c(
                                  "td",
                                  { attrs: { colspan: "5" } },
                                  [
                                    _c("v-progress-linear", {
                                      staticClass: "mt-0",
                                      attrs: { height: 2 },
                                      model: {
                                        value: _vm.files_data[i].progress,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.files_data[i],
                                            "progress",
                                            $$v
                                          )
                                        },
                                        expression: "files_data[i].progress"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.files_data[i].block_reasons, function(
                            blockReason,
                            brIndex
                          ) {
                            return _c(
                              "tr",
                              {
                                key: "blockReason" + brIndex,
                                staticClass: "background--text text--lighten-4"
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "pt-0",
                                    staticStyle: { "vertical-align": "middle" },
                                    attrs: { colspan: "5" }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          size: 18,
                                          color: "background lighten-4"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\terror\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(blockReason) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.files_data[i].error
                            ? _c("tr", { staticClass: "error--text" }, [
                                _c(
                                  "td",
                                  {
                                    staticClass: "pt-0",
                                    staticStyle: { "vertical-align": "middle" },
                                    attrs: { colspan: "5" }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { size: 18, color: "error" } },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\terror\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.files_data[i].error) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c("tbody", [
                      _vm.dropped_files.length > 1
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-right pt-3",
                                attrs: { colspan: "5" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "text-none ma-0",
                                    attrs: {
                                      small: "",
                                      color: "primary color--text",
                                      loading: _vm.uploading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.upload(
                                          _vm.dropped_files,
                                          _vm.files_data
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-3",
                                        attrs: { color: "color" }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\tupload_file\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tMulti upload\n\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6112f98e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6112f98e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/filesystem/explorer_uploader.vue
// module id = null
// module chunks = 